export const EmptySearchComponent = {
  bindings: {},
  templateUrl: 'components/Scenes/empty-search/empty-search.html',
};
